export const storageHistory = {
	title: "Informe de Movimientos",
	description:
		"En este informe, es posible analizar los movimientos de entrada y salida por inventario, producto y categoría durante el período deseado, teniendo en cuenta las pérdidas asociadas.",
	label: "Movimientos",
	filename: "informe-de-movimientos",
	print: "Imprimir",
	export: "Descargar en Excel",
	cleanFilters: "Limpiar filtros",
	emptyState: {
		title: "Seleccione y aplique los filtros para comenzar",
		description:
			"Debe seleccionar al menos un inventario, una categoría o un producto y el período para comenzar",
	},
	storages: {
		label: "Inventarios",
		placeholder: "Busque por inventario",
	},
	filterBy: {
		label: "Filtrar por",
		category: "Categoría",
		product: "Producto",
	},
	products: {
		label: "Productos",
		placeholder: "Busque por producto",
	},
	categorys: {
		label: "Categorías",
		placeholder: "Busque por categoría",
	},
	period: "Período",
	filter: "Aplicar filtros",
	hideProducts: "No mostrar elementos con ficha técnica",
	dateFilterBy: {
		label: "Filtrar período por",
		options: {
			events: "Eventos entre el período",
			interval: "Todos entre el período",
		},
	},
	columns: {
		name: "Producto",
		ube: "Unidad",
		inicial: "Cantidad Inicial",
		input: "Entrada de productos",
		transfer: "Transferencia interna",
		sell: "Ventas",
		productionIn: "Entrada de producción",
		productionOut: "Salida de producción",
		lost: "Pérdidas",
		manual: "Ajuste Manual",
		cardExchange: "Devoluciones",
		result: "Final",
		lossPercentage: "Porcentaje de pérdidas",
	},
	editModal: {
		title: "Editar alertas de inventario para {{productName}}",
		deleteWarning: "¿Está seguro que desea eliminar la alerta de {{productName}}?",
		delete: "Eliminar alerta",
		storageIn: "Inventario en",
		alert: "Alerta",
		critical: "Crítico",
		storage: "Inventario",
		below: "abajo de",
		invalidText:
			"El valor de inventario en alerta no puede ser menor que el valor de inventario crítico",
	},
	printable: {
		product: "Producto",
		initialQuantity: "Cant. Inicial",
		productEntry: "Ent. de Prod.",
		internalTransfer: "Transf. Interna",
		sales: "Ventas",
		productionEntry: "Ent. de Producción",
		productionOutput: "Salida de Producción",
		losses: "Pérdidas",
		manualAdjustment: "Ajuste Manual",
		final: "Final",
		withoutProducts: "Sin productos seleccionados",
	},
	storageReport: "Informe de inventario",
};
